// Literal hex for non-CSS contexts (OG images via Satori, PWA manifest,
// facility-map markers, email HTML) where CSS variables can't be read.
// Values mirror the design tokens in src/app/globals.css; keys are kept stable
// to avoid churning importers.
export const brandNames = {
  agent: "Atlas Agent",
  agentShort: "Agent",
  agentPro: "Atlas Agent Pro",
  agentProShort: "Agent Pro",
  portal: "Creative Strategies Atlas",
  portalShort: "CS Atlas",
  publication: "The Diligence Stack",
  publisher: "Creative Strategies",
} as const;

export const brandHex = {
  action: "#AD4119", // light-mode primary
  backgroundDark: "#081A33", // dark mode background
  border: "#E5E7EB", // border
  cloudGray: "#626974", // muted-foreground
  hardwarePeach: "#F2A07A", // accent
  ink: "#1A1A1A", // foreground
  ivory: "#FAFAF8", // background
  mutedForegroundDark: "#AAB7C6", // dark mode muted-foreground
  onPrimary: "#FFFFFF", // primary-foreground
  paper: "#FFFFFF", // card
  secondaryDark: "#16356A", // dark mode secondary
  serviceGold: "#F2B233", // chart-4
  siliconOrange: "#E8632A", // chart-1
  softwareOrange: "#DEA129", // supporting warm data accent
  stackRed: "#B42318", // destructive
} as const;

// Approved editorial artwork surfaces, separate from the application theme.
export const socialCardHex = {
  notesPaper: "#FFFBF5",
  notesBand: "#F7ECD9",
  notesRule: "#E6D5C0",
  notesCaption: "#82674C",
  modelsPaper: "#F0F5FA",
  modelsSidebar: "#0E2A52",
} as const;

// UI chrome uses the SVG masters. `rasterSrc` is the PNG fallback for email
// clients and Satori OG cards, which do not reliably render SVG.
export const brandLogoAssets = {
  dsLogo: {
    alt: "CS Atlas monogram",
    height: 96,
    rasterSrc: "/assets/cs-atlas-monogram.png",
    src: "/assets/cs-atlas-monogram.svg",
    width: 96,
  },
  logoSquare: {
    alt: "CS Atlas",
    height: 96,
    rasterSrc: "/assets/cs-atlas-icon.png",
    rasterSrcDark: "/assets/cs-atlas-icon-dark.png",
    src: "/assets/cs-atlas-icon.svg",
    srcDark: "/assets/cs-atlas-icon-dark.svg",
    width: 96,
  },
  squareLockup: {
    alt: "CS Atlas",
    height: 96,
    rasterSrc: "/assets/cs-atlas-icon.png",
    rasterSrcDark: "/assets/cs-atlas-icon-dark.png",
    src: "/assets/cs-atlas-icon.svg",
    srcDark: "/assets/cs-atlas-icon-dark.svg",
    width: 96,
  },
  wordmark: {
    alt: "Creative Strategies Atlas",
    height: 107,
    rasterSrc: "/assets/cs-atlas-wordmark.png",
    rasterSrcDark: "/assets/cs-atlas-wordmark-dark.png",
    src: "/assets/cs-atlas-wordmark.svg",
    srcDark: "/assets/cs-atlas-wordmark-dark.svg",
    width: 240,
  },
} as const;
